import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { contentKeys } from '../queryKeys'
import { submitForApproval } from '..'

const useSubmitForApprovalMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(submitForApproval, {
    onError: () => {
      errorToast('Something went wrong. Please try again.')
    },
    onSuccess: (content) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
    },
  })
}

export default useSubmitForApprovalMutation
